import React, { useContext, useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom';


import { SocketContext } from '../context/SocketContext'
import { getUsuarioStorage } from '../helpers/getUsuarioStorage'
import { useHideMenu } from '../hooks/useHideMenu'

import { NoAcceso } from '../components/NoAcceso';


// import logo from "../assets/logo.png";
import logo from "../assets/femcc-01/logo.png";




export const EnBlanco = () => {

    let [usuario] = useState( getUsuarioStorage() )
    const entidad = usuario.entidad;

    const navigate = useNavigate();
    useEffect(() => {
      if(usuario.uidUsuario === null){
          // return <Navigate to="/ingreso" />
          navigate("/Ingreso")
      }
    }, [usuario.uidUsuario, navigate])


    useHideMenu(false);
  
  
        return(
            <div className= 'p-1' 
                style={{
                    minHeight:'100vh',
                    backgroundImage:`url('${ logo }')`,
                    backgroundRepeat: 'no-repeat',
                    backgroundPosition: 'center',
                    // width: '100%',
                    height: 'auto',
                    margin: 'auto',
                    opacity: '0.3'
                }}
            >
            
                <div className="d-grid gap-2 mt-5">
                    {/* <img id="imgPrint" style={{height:'auto',width:'100%', opacity: "0.3"}} src={ logo } alt='' /> */}
                </div>
            
            </div >
        )
         
}
